import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appMobileMask]',
})
export class MobileMaskDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private ngControl: NgControl
  ) {}

  @HostListener('input')
  onInput() {
    const input = this.el.nativeElement;
    const raw = input.value;

    const hasPlus = raw.startsWith('+');
    let digits = raw.replace(/\D/g, '');

    const isAustralianIntl = hasPlus && digits.startsWith('61');

    let formatted: string;

    if (isAustralianIntl) {
      digits = digits.substring(2).substring(0, 9);
      let rest = '+61 ';
      if (digits.length <= 3) {
        rest += digits;
      } else if (digits.length <= 6) {
        rest += digits.substring(0, 3) + ' ' + digits.substring(3);
      } else {
        rest += digits.substring(0, 3) + ' ' + digits.substring(3, 6) + ' ' + digits.substring(6);
      }
      formatted = rest;
    } else if (hasPlus) {
      // Non-AU international (e.g. +44, +64) — free text.
      // Keep the leading +, allow digits, spaces, hyphens, parens; strip anything else.
      formatted = '+' + raw.substring(1).replace(/[^\d\s\-()]/g, '');
    } else {
      digits = digits.substring(0, 10);
      if (digits.length <= 4) {
        formatted = digits;
      } else if (digits.length <= 7) {
        formatted = digits.substring(0, 4) + ' ' + digits.substring(4);
      } else {
        formatted = digits.substring(0, 4) + ' ' + digits.substring(4, 7) + ' ' + digits.substring(7);
      }
    }

    if (formatted !== raw) {
      input.value = formatted;
    }
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(formatted, { emitEvent: false });
    }
  }
}
